import gsap from 'gsap'

export class Header {
  constructor() {
    this._headerWrap = document.querySelector('.header-wrap')
    this._burger = document.querySelector('#burger')
    this._mobileMenu = document.querySelector('.header-nav__mobile')
    this._scrollThreshold = 10
    this._itemsWithChildren = document.querySelectorAll('.menu-item-has-children')

    if (this._itemsWithChildren.length) {
      this._itemsWithChildren.forEach(item => {
        this.handleSubmenu(item)
      })
    }

    if (this._burger) {
      this._burger.addEventListener('click', this.handleBurger)
    }

    this.onScroll()
    window.addEventListener('scroll', this.onScroll, { passive: true })

    if (window.__lenis) {
      window.__lenis.on('scroll', this.onScroll)
    }
  }

  handleBurger = () => {
    this._mobileMenu.classList.toggle('is-active')
  }

  onScroll = (event) => {
    if (!this._headerWrap) {
      return
    }

    const scrollY = typeof event === 'object' && event?.scroll != null
      ? event.scroll
      : (window.__lenis?.scroll ?? window.scrollY ?? 0)

    this._headerWrap.classList.toggle('is-scrolled', scrollY > this._scrollThreshold)
    this._headerWrap.classList.toggle('scrolled', scrollY > this._scrollThreshold)
  }

  handleSubmenu = (item) => {

    const submenu = item.querySelector('.sub-menu')
    const link = item.querySelector(':scope > a')
    const isMobile = /Mobi|Android/i.test(navigator.userAgent)

    const openAnimation = gsap.to(submenu, {
      height: 'auto',
      duration: 0.5,
      autoAlpha: 1,
      ease: 'power2.inOut',
      paused: true,
    })

    let clicked = false;

    link.addEventListener('click', (e) => {
      if (isMobile && !clicked) {
        e.preventDefault()
      }
      clicked = !clicked
    })

    item.addEventListener('mouseover', (e) => {
      openAnimation.play()
    })

    item.addEventListener('mouseleave', (e) => {
      openAnimation.reverse()
      clicked = false
    })

  }

}
